var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "h-full" },
    [
      _c(
        "div",
        { staticClass: "flex flex-row flex-wrap gap-4 items-center py-3" },
        [
          _c(
            "div",
            {
              staticClass: "flex flex-row flex-wrap gap-4 items-center w-full",
            },
            [
              _c(
                "div",
                { staticClass: "flex-1 min-w-[200px]" },
                [
                  _c("FormGroup", {
                    attrs: {
                      title: "",
                      type: "search",
                      iconStyle: "customIcon",
                      inputClass: "customFormInput fullwidthform",
                      placeholder: "Search for Resource Name",
                      debounceTime: 500,
                    },
                    model: {
                      value: _vm.searchName,
                      callback: function ($$v) {
                        _vm.searchName = $$v
                      },
                      expression: "searchName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex-1 min-w-[200px]" },
                [
                  _c("FormGroup", {
                    attrs: {
                      title: "",
                      type: "search",
                      iconStyle: "customIcon",
                      inputClass: "customFormInput fullwidthform",
                      placeholder: "Search by Address",
                      debounceTime: 500,
                    },
                    model: {
                      value: _vm.searchLocation,
                      callback: function ($$v) {
                        _vm.searchLocation = $$v
                      },
                      expression: "searchLocation",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "flex-1 min-w-[200px] small-dropdown max-w-[220px]",
                },
                [
                  _c(
                    "FormGroup",
                    [
                      _c("TitlesMultiselect", {
                        attrs: {
                          placeholder: "Classification type",
                          getcontainerStyle: "customWidthInput",
                        },
                        on: { input: _vm.handleFilterChange },
                        model: {
                          value: _vm.additionalFilters.titles,
                          callback: function ($$v) {
                            _vm.$set(_vm.additionalFilters, "titles", $$v)
                          },
                          expression: "additionalFilters.titles",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex-1 min-w-[200px]" },
                [
                  _c(
                    "FormGroup",
                    [
                      _c("FormDatepicker", {
                        attrs: {
                          iconStyle: "customIcon",
                          isCalenderIcon: true,
                          inputClass: "customFormInput",
                          calendarClass:
                            "right-0 sm:right-0 sm:left-auto left-0 sm:left-auto",
                          customInputClass:
                            "rounded-lg text-storm-gray text-sm h-1",
                          label: "",
                          placeholder: "Date",
                        },
                        model: {
                          value: _vm.searchDate,
                          callback: function ($$v) {
                            _vm.searchDate = $$v
                          },
                          expression: "searchDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "flex flex-row flex-wrap gap-4 items-center w-full",
            },
            [
              _c(
                "div",
                { staticClass: "flex-1 small-dropdown custom-width" },
                [
                  _c(
                    "FormGroup",
                    [
                      _c("SkillsMultiselect", {
                        attrs: { placeholder: "Tags", multiple: "" },
                        on: { input: _vm.handleFilterChange },
                        model: {
                          value: _vm.additionalFilters.skills,
                          callback: function ($$v) {
                            _vm.$set(_vm.additionalFilters, "skills", $$v)
                          },
                          expression: "additionalFilters.skills",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex-shrink-0 custom-width-small" },
                [
                  _c("FormGroup", {
                    attrs: {
                      title: "",
                      type: "text",
                      iconStyle: "customIcon",
                      inputClass: "customFormInput",
                      placeholder: "Rate Min",
                      suffix: "$",
                      debounceTime: 500,
                    },
                    on: { input: _vm.handleFilterChange },
                    model: {
                      value: _vm.additionalFilters.minRate,
                      callback: function ($$v) {
                        _vm.$set(_vm.additionalFilters, "minRate", $$v)
                      },
                      expression: "additionalFilters.minRate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex-shrink-0 custom-width-small" },
                [
                  _c("FormGroup", {
                    attrs: {
                      title: "",
                      type: "text",
                      iconStyle: "customIcon",
                      inputClass: "customFormInput",
                      placeholder: "Rate Max",
                      suffix: "$",
                      debounceTime: 500,
                    },
                    on: { input: _vm.handleFilterChange },
                    model: {
                      value: _vm.additionalFilters.maxRate,
                      callback: function ($$v) {
                        _vm.$set(_vm.additionalFilters, "maxRate", $$v)
                      },
                      expression: "additionalFilters.maxRate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex-shrink-0 ml-auto" },
                [
                  _c("UiButtonMessage", {
                    attrs: {
                      buttonClass: "customAdd",
                      buttonText: "Reset",
                      textClass: "customText customOnlyText",
                    },
                    on: { click: _vm.handleReset },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c("div", { staticClass: "text-gray-600 text-sm mb-6 mt-2" }, [
        _vm._v("Total : "),
        _c("span", { staticClass: "font-bold text-black" }, [
          _vm._v(_vm._s(_vm.raw_Contractors?.total?.aggregate?.count || 0)),
        ]),
      ]),
      _c(
        "LoadingOverlay",
        {
          attrs: {
            loading: _vm.$apollo.queries.raw_Contractors.loading,
            hasData: _vm.contractors.length > 0,
          },
        },
        [
          _c("Scheduler", {
            attrs: {
              resources: _vm.resources,
              events: _vm.events,
              listeners: _vm.listeners,
              schedularType: _vm.schedularType,
            },
          }),
        ],
        1
      ),
      _vm.modalShown && _vm.modalType === "project"
        ? _c("ProjectSchedulerEdit", {
            attrs: {
              project: _vm.projectInfoForModal,
              modalShown: _vm.modalShown,
              currentUser: _vm.currentUser,
              companyId: _vm.companyId,
            },
            on: {
              projectUpdated: _vm.handleIconClose,
              close: _vm.handleCloseModal,
            },
          })
        : _vm._e(),
      _vm.modalShown && _vm.modalType === "activity"
        ? _c("ActivityFormModal", {
            attrs: {
              project: _vm.projectInfoForModal,
              projectActivity: _vm.activityInfoForModal,
              currentUserRole: _vm.currentUser.role,
              contractorId: _vm.contractorIdForModal,
              companyId: _vm.companyId,
              currentUserId: _vm.currentUser.id,
              show_cancel_draft_actions: false,
            },
            on: {
              activityAdded: _vm.handleCollectionUpdated,
              activityUpdated: _vm.refetchCollection,
              close: _vm.handleCloseModal,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "activity_actions_slot",
                  fn: function () {
                    return [
                      _c("p", { staticClass: "text-sm flex items-center" }, [
                        _c(
                          "span",
                          { staticClass: "text-gray-600" },
                          [_c("ScheduleInfoIcon", { staticClass: "mr-1 w-4" })],
                          1
                        ),
                        _vm._v(
                          " Tasks created on the calendar are final and cannot be saved as draft. "
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2451429914
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }